<template lang="pug">
    div
        v-row
            .col-2
                v-card(outlined)
                    v-system-bar(height="50")
                        v-spacer
                        v-btn(v-if="!loading" icon outlined small @click="addNewPage()") 
                            v-icon.mr-0 mdi-plus
                    v-progress-linear(v-if="loading" :indeterminate="true")
                            
                    v-list
                        v-list-item-group(v-model="listitem" color="primary")
                            v-list-item(v-for="item in pages" :key="item.id" @click="selectPage(item)" :class="listParams(item).class")
                                v-list-item-content
                                    v-list-item-title {{ $showLocalizedField(item.name, locale).text }}
                                    v-list-item-subtitle {{ item.alias }} 
                                    v-list-item-subtitle 
                                        v-icon(v-if="item.hasUnsavedChanges" color="red") mdi-alert
                                        span {{ listParams(item).subtitle }}
            .col-10
                v-card(outlined v-if="editPage")
                    v-system-bar(height="50")
                        div(v-if="haveChanges")
                            v-icon(color="red" large) mdi-alert
                            span Есть несохранённые изменения
                        v-spacer
                        v-btn.ml-1(v-if="pageMode=='view'" outlined icon small @click="setMode('edit')")
                            v-icon.mr-0 mdi-pencil
                        v-btn.ml-1(v-if="pageMode=='edit'" outlined icon small @click="setMode('view')")
                            v-icon.mr-0 mdi-eye
                        v-btn.ml-1(v-if="editPage.id" outlined icon small @click="showDelPageDialog()") 
                            v-icon.mr-0 mdi-delete

                    v-card-text(v-if="pageMode=='view'")
                        div locale: {{ locale }}
                        div id: {{ editPage.id || 'null' }}
                        div srt: {{ editPage.srt }}
                        div alias: {{ editPage.alias }}

                        div name : {{ $showLocalizedField(editPage.name, locale).text }}

                        div title: {{ $showLocalizedField(editPage.title, locale).text }}
                        div discription: {{ $showLocalizedField(editPage.discription, locale).text }}
                        div content: 
                            div(v-html="$showLocalizedField(editPage.content, locale).text")

                    v-card-text(v-if="pageMode=='edit'") 
                        v-form(v-on:submit.prevent="onSubmit")
                            v-text-field(outlined v-model="editPage.srt" label="Порядок вывода в меню" required :error-messages="srtErrors" @input="$v.editPage.srt.$touch()" @blur="$v.editPage.srt.$touch()")
                            v-text-field(outlined v-model="editPage.alias" label="Алиас" required :error-messages="aliasErrors" @input="$v.editPage.alias.$touch()" @blur="$v.editPage.alias.$touch()")

                            v-card.mb-7(outlined) 
                                v-card-title Локализованое поле Имя
                                v-card-text
                                    v-text-field(v-for="(name,index) in editPage.name" :key="index" v-model="name.text" :label="'Имя ('+name.locale+')'" @input="name.validate(index)" @blur="name.validate(index)" :error-messages="name.errors" outlined required)
                                        v-btn(v-if="index>0" slot="append" icon outlined small @click="removeLocalizedField('name',index)")
                                            v-icon mdi-close
                                    v-menu(v-if="availableFieldLocales('name').length > 0" open-on-hover)
                                        template(v-slot:activator="{ on }")
                                            v-btn(v-on="on") Добавить локализацию
                                        v-card
                                            v-list-item(v-for="item in availableFieldLocales('name')" :key="item.value" v-text="item.text[locale]" @click="addLocalizedField('name',item)")

                            v-card.mb-7(outlined) 
                                v-card-title Локализованое поле Титл
                                v-card-text
                                    v-text-field(v-for="(title,index) in editPage.title" :key="index" v-model="title.text" :label="'Титл ('+title.locale+')'" @input="title.validate(index)" @blur="title.validate(index)" :error-messages="title.errors" outlined required)
                                        v-btn(v-if="index>0" slot="append" icon outlined small @click="removeLocalizedField('title',index)")
                                            v-icon mdi-close
                                    v-menu(v-if="availableFieldLocales('title').length > 0" open-on-hover)
                                        template(v-slot:activator="{ on }")
                                            v-btn(v-on="on") Добавить локализацию
                                        v-card
                                            v-list-item(v-for="item in availableFieldLocales('title')" :key="item.value" v-text="item.text[locale]" @click="addLocalizedField('title',item)")

                            v-card.mb-7(outlined) 
                                v-card-title Локализованое поле Описание
                                v-card-text
                                    v-textarea(v-for="(discription,index) in editPage.discription" :key="index" v-model="discription.text" :label="'Описание ('+discription.locale+')'" @input="discription.validate(index)" @blur="discription.validate(index)" :error-messages="discription.errors" outlined required)
                                        v-btn(v-if="index>0" slot="append" icon outlined small @click="removeLocalizedField('discription',index)") 
                                            v-icon mdi-close
                                    v-menu(v-if="availableFieldLocales('discription').length > 0" open-on-hover)
                                        template(v-slot:activator="{ on }")
                                            v-btn(v-on="on") Добавить локализацию
                                        v-card
                                            v-list-item(v-for="item in availableFieldLocales('discription')" :key="item.value" v-text="item.text[locale]" @click="addLocalizedField('discription',item)")

                            v-card.mb-7(outlined) 
                                v-card-title Локализованое поле Контент
                                v-card-text
                                    v-card.mb-7(outlined v-for="(content,index) in editPage.content" :key="index")
                                        v-system-bar(height="50" color="#fff") Контент ({{ content.locale }})
                                            v-spacer
                                            v-btn(v-if="index>0" icon outlined small @click="removeLocalizedField('content',index)") 
                                                v-icon.mr-0 mdi-close
                                        vue-editor(v-model="content.text" :id="'editor_'+content.locale")

                                    v-menu(v-if="availableFieldLocales('content').length > 0" open-on-hover)
                                        template(v-slot:activator="{ on }")
                                            v-btn(v-on="on") Добавить локализацию
                                        v-card
                                            v-list-item(v-for="item in availableFieldLocales('content')" :key="item.value" v-text="item.text[locale]" @click="addLocalizedField('content',item)")

                            v-card-actions
                                v-btn(v-if="haveChanges" type="submit") Сохранить 
                                    template(v-if="editPage.id") изменения
                                v-btn(@click="cancelPage") Отмена

                    v-dialog(v-model="dialog" persistent max-width="290")
                        v-card
                            v-card-title 
                                v-icon(color="red" large) mdi-alert 
                                span Внимание
                            v-card-text Удалить страницу {{ selectedPage.name[0].text }}
                            v-card-actions
                                v-btn(@click="deletePage()") Удалить
                                v-btn(@click="dialog = false") Отмена


</template>

<script>

    import { VueEditor } from "vue2-editor";

    import { validationMixin } from 'vuelidate'
    import { required, integer } from 'vuelidate/lib/validators'

    import { mapState, mapMutations } from "vuex";

    import { pagesService } from '@/_services'

    export default {
        name:'pages',
        mixins: [validationMixin],
        validations: {
            editPage: {
                srt: { required, integer },        
                alias: { required  }
            }
        },
        components: {
            VueEditor
        },

        mounted () {
            this.loadPagesList()
        },

        computed: {
            ...mapState(['locale','locales']),

            srtErrors () {
                const errors = []
                if (!this.$v.editPage.srt.$dirty) return errors
                !this.$v.editPage.srt.required && errors.push('Обязательное поле')
                return errors
            },
            aliasErrors () {
                const errors = []
                if (!this.$v.editPage.alias.$dirty) return errors
                !this.$v.editPage.alias.required && errors.push('Обязательное поле')
                var re = /^[A-Za-z0-9_]+$/gi
                if (!re.test(this.editPage.alias)) errors.push('Только латинские буквы, цифры и _')
                if (this.pages.some(p => p.alias == this.editPage.alias && p.id != this.editPage.id)) errors.push('Страница с таким алиасом уже существует')
                return errors
            },
            defaultLocale(){
                return this.locales.filter(f => f.default == true)[0]
            },
            haveChanges(){
                let changes = false
                if (!changes && !this.selectedPage.id) changes = true
                if (!changes && this.selectedPage.srt != this.editPage.srt) changes = true
                if (!changes && this.selectedPage.alias != this.editPage.alias) changes = true
                if (!changes) changes = this.checkFieldChanges('name')
                if (!changes) changes = this.checkFieldChanges('title')
                if (!changes) changes = this.checkFieldChanges('discription')
                if (!changes) changes = this.checkFieldChanges('content')
                
                this.setHasChanges(changes)
                return changes
            }
        },

        methods: {
            ...mapMutations('pages',['setPages']),
            setHasChanges(changes){
                this.selectedPage.hasUnsavedChanges = changes
            },
            checkFieldChanges(fieldName){
                let changes = false
                for (let el of this.editPage[fieldName]){
                    let fld = this.selectedPage[fieldName].filter(f => f.locale == el.locale)[0] || null
                    if (!fld || el.text != fld.text) changes = true
                }
                if (!changes){
                    for (let el of this.selectedPage[fieldName]){
                        let fld = this.editPage[fieldName].filter(f => f.locale == el.locale)[0] || null
                        if (!fld || el.text != fld.text) changes = true
                    }
                }
                return changes
            },
            loadPagesList(){
                this.loading = true
                pagesService.loadPagesList().then(data=>{
                    this.pages = data
                    this.setPages(data)
                    this.loading = false

                    if (this.openPage) {
                        let op = this.pages.filter(e=>{return e.alias == this.openPage})[0] || null
                        if (op) this.selectPage(op)
                        this.openPage = null
                    }
                })
            },
            listParams(item){
                let par = {class:'',subtitle:''}
                if (!item.id && item.hasUnsavedChanges) par = {class:'newNotSave',subtitle:'Новая не сохранённая страница'}
                if (item.id && item.hasUnsavedChanges) par = {class:'haveChanges',subtitle:'Есть несохранённые изменения'}
                return par
            },

            availableFieldLocales(field){
                let locs = this.locales.filter(loc=>{
                    let dflt = !this.editPage[field].some(f => f.locale == loc.value)
                    return dflt
                })
                return locs
            },
            addNewPage(){
                let pCount = this.pages.filter(p=>{
                    if (!p.alias) return false
                    return p.alias.includes('new_page')
                }).length

                let pNum = pCount == 0 ? '' : ' ('+pCount+')'
                let npNem = pCount == 0 ? '' : '_'+pCount
                let page = {
                    hasUnsavedChanges:true,
                    srt:0,
                    alias:'new_page'+npNem,
                    name:[
                        {
                            locale:this.defaultLocale.value,
                            text:'Новая страница'+pNum
                        }
                    ],
                    title:[
                        {
                            locale:this.defaultLocale.value,
                            text:'Новая страница'+pNum
                        }
                    ],
                    discription:[
                        {
                            locale:this.defaultLocale.value,
                            text:'Новая страница'+pNum
                        }
                    ],
                    content:[
                        {
                            locale:this.defaultLocale.value,
                            text:'Новая страница'+pNum
                        }
                    ]
                }
                this.pages.push(page)
                this.selectPage(page)
                this.listitem = this.pages.length-1
                
            },

            cancelPage(){
                this.setHasChanges(false)
                this.selectedPage = null
                if (!this.editPage.id) this.pages.splice(this.listitem, 1)
                this.editPage = null
                
            },

            selectPage(item){
                this.selectedPage = item
                this.editPage = JSON.parse(JSON.stringify(this.selectedPage))

                if (!this.selectedPage.id) {
                    this.pageMode='edit'
                    this.$set(this.selectedPage,'hasUnsavedChanges',true)
                } else {
                    this.pageMode='view'
                    if (!this.selectedPage.hasUnsavedChanges) this.$set(this.selectedPage,'hasUnsavedChanges',false)
                }

                this.assignFieldsFunctions()
            },

            assignFieldsFunctions(){
                this.editPage.name.map(el => {this.addFunction('name',el)})
                this.editPage.title.map(el => {this.addFunction('title',el)})
                this.editPage.discription.map(el => {this.addFunction('discription',el)})
            },

            addFunction(fieldName, field){
                let _self = this.editPage
                this.$set(field,'errors',[])
                this.$set(field,'validate',function(index){
                    let err = []
                    
                    if (_self[fieldName][index].text.trim() == '') {
                        err.push('Обязательное поле')
                    }
                    field.errors = err
                })
                return field
            },

            addLocalizedField(field,locale){
                let exist = this.editPage[field].some(f => f.locale == locale.value)
                if (!exist){
                    let defaultField = this.editPage[field][0]

                    let newField = {}
                    this.$set(newField,'locale',locale.value)
                    this.$set(newField,'text',defaultField.text)

                    this.addFunction(field,newField)
                    this.editPage[field].push(newField)
                }
            },

            removeLocalizedField(field,fieldIndex){
                this.editPage[field].splice(fieldIndex, 1)
            },

            setMode(mode){
                this.pageMode = mode
            },

            showDelPageDialog(){
                this.dialog = true
            },

            deletePage(){
                pagesService.delPage(this.selectedPage.id).then(data=>{
                    this.loadPagesList()
                    this.editPage = null
                    this.selectedPage = null
                    this.dialog = false
                })
            },

            validate(){
                this.$v.$touch()
                let isInvalid = this.$v.$invalid

                if (!isInvalid) isInvalid = this.editPage.name.some(t => t.errors.length > 0)
                if (!isInvalid) isInvalid = this.editPage.title.some(t => t.errors.length > 0)
                if (!isInvalid) isInvalid = this.editPage.discription.some(t => t.errors.length > 0)

                return isInvalid
            },

            onSubmit(){
                if (!this.validate()){
                    this.$nextTick(() => {

                        pagesService.savePage(this.editPage).then(data=>{
                            this.loadPagesList()
                            this.openPage = this.editPage.alias
                        })
                    })
                }
            }
        },

        data() {
            return {
                loading:false,
                listitem:-1,
                pages:[],
                selectedPage:null,
                editPage:null,
                pageMode:'',
                openPage:null,
                dialog:false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .newNotSave {background: #FA8072;}
    .haveChanges {background: #FFD700;}
</style>